<template>
	<form class="profile-form__credentials form__input flex-vertical center-align" @submit.prevent="validateForm" @keydown="form.onKeydown($event)">
		<label for="name" class="label left-align left-align">
			<b>{{ $t('fields.name') }}</b>
		</label>

		<input
			name="name"
			type="text"
			v-model="form.name"
			class="input"
			:class="{ 'is-danger': form.errors.has('name') }"
			:placeholder="$t('auth.your_name')"
		/>

		<label for="email" class="label left-align">
			<b>{{ $t('fields.email') }}</b>
		</label>

		<input
			name="email"
			type="text"
			v-model="form.email"
			class="input"
			:class="{ 'is-danger': form.errors.has('email') }"
			:placeholder="$t('auth.your_email')"
			disabled
		/>

		<label for="email" class="label left-align">
			<b>{{ $t('fields.phone') }}</b>
		</label>
		<div class="phone-input__wrapper flex-horizontal">
			<select class="b-select b-select__phone-code" name="countryCode" v-model="form.countryCode">
				<option v-bind:value="420">+420</option>
				<option v-bind:value="421">+421</option>
			</select>
			<input
				class="b-input__phone input form__input"
				type="tel"
				name="phone"
				v-model="form.phone"
				:class="{ 'is-danger': form.errors.has('phone') }"
				:placeholder="$t('auth.your_phone')"
			/>
		</div>

		<v-button :loading="form.busy" :disabled="!changeProfile">{{ $t('save') }}</v-button>
	</form>
</template>

<script>
import Form from 'vForm'
import { mapGetters } from 'vuex'
export default {
	computed: {
		...mapGetters({
			user: 'auth/user',
		}),
		changeProfile() {
			if (!this.form.name) return false
			return this.form.name != this.user.name || this.form.countryCode + this.form.phone != (this.user.phone ?? this.form.countryCode)
		},
	},

	data() {
		return {
			form: new Form({
				name: null,
				email: null,
				countryCode: 420,
				phone: null,
			}),
		}
	},

	created() {
		this.form.name = this.user.name
		this.form.email = this.user.email
		if (this.user.phone) {
			this.form.countryCode = this.user.phone.substr(0, 3)
			this.form.phone = this.user.phone.substr(3)
		}
	},

	methods: {
		validateForm() {
			this.update()
		},
		async update() {
			try {
				let { data } = await this.form.patch('/user/profile/update')
				this.$store.commit('auth/FETCH_USER_SUCCESS', data)
				this.$notify(this.$t('success_change_personal_data'), 'success')
			} catch ({ response }) {
				// this.$notify(response.data.message)
				this.$notifyAllErrors(response.data.errors)
			}
		},
	},
}
</script>

<style lang="scss" scoped></style>
